import Auth from 'shared/context/Auth'
import { queryKeys } from 'hooks/queryKeys'
import { useQuery } from '@tanstack/react-query'
import type { PrivateInvestorCheckResponse } from 'shared/context/Auth'

interface UsePrivateInvestorOptions {
  userId?: string
  projectId?: string
  enabled?: boolean
}

export function usePrivateInvestor({ userId, projectId, enabled = true }: UsePrivateInvestorOptions) {
  return useQuery({
    queryKey: queryKeys.privateInvestor(userId ?? '', projectId ?? ''),
    queryFn: (): Promise<PrivateInvestorCheckResponse> => Auth.checkPrivateInvestor({ projectId }),
    enabled: enabled && !!userId && !!projectId,
  })
}

export interface PrivateInvestorProjectStatus {
  projectId?: string
  status?: string
  isAllowed?: boolean
}

/** Every project's private-investor status in one call — the backend supports omitting
 *  `projectId`. One fetch per user instead of one per project visited. */
export function usePrivateInvestorProjects({ userId, enabled = true }: { userId?: string; enabled?: boolean }) {
  return useQuery({
    queryKey: queryKeys.privateInvestorAll(userId ?? ''),
    queryFn: async (): Promise<PrivateInvestorProjectStatus[]> => {
      const { list } = await Auth.checkPrivateInvestor()
      return (list as PrivateInvestorProjectStatus[] | undefined) ?? []
    },
    enabled: enabled && !!userId,
  })
}
